// extracted by mini-css-extract-plugin
export var label = "_gw-2";
export var slideContainer = "_gw-0";
export var slider = "_gw-1";